import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createProject } from '../api/projectApi';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from '../translations';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import ProjectForm from '../components/project/ProjectForm';
import PageHeader from '../components/project/PageHeader';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const CreateProjectPage = () => {
  const [formData, setFormData] = useState({
    project_name: '',
    project_code: '',
    hotel_name: '',
    department_name: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  // Hook'lardan gerekli değişkenleri al
  const { user } = useAuth();
  const { language } = useLanguage();

  const handleSubmit = async (formData) => {
    setLoading(true);
    setError('');

    try {
      // Backend'e gönderilecek data
      const projectData = {
        project_name: formData.projectName,
        project_code: formData.projectCode,
        owner_department_id: user.department, // Bu doğru - ID değerini alır
        project_icon: formData.projectIcon, // Icon verisi
        background_image: formData.backgroundImage, // Background image verisi
        // hotel_id backend'de otomatik ekleniyor
      };

      const response = await createProject(projectData);
      
      if (response.success) {
        // Başarılı oluşturma sonrası yönlendirme
        navigate('/projects', { 
          state: { 
            message: 'Proje başarıyla oluşturuldu!' 
          } 
        });
      }
    } catch (error) {
      setError(error.message || 'Proje oluşturulurken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/projects');
  };

  return (
    <div className="p-8 bg-gray-50 dark:bg-gray-900 min-h-screen">
      <div className="max-w-4xl mx-auto">
        {/* Page Header */}
        <PageHeader 
          title={language === 'tr' ? 'Yeni Proje Oluştur' : 'Create New Project'}
          description={language === 'tr' ? 'Yeni bir proje oluşturun ve takımınızla çalışmaya başlayın.' : 'Create a new project and start working with your team.'}
          onBack={() => navigate('/projects')}
        />

        {/* Main Content */}
        <div className="mt-8">
          <Card>
            <CardHeader>
              <CardTitle className="text-xl text-gray-900 dark:text-white">
                {language === 'tr' ? 'Proje Bilgileri' : 'Project Information'}
              </CardTitle>
              <CardDescription className="text-gray-600 dark:text-gray-300">
                {language === 'tr' 
                  ? 'Aşağıdaki formu doldurarak yeni bir proje oluşturabilirsiniz.'
                  : 'Fill out the form below to create a new project.'
                }
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ProjectForm 
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                isLoading={loading}
                error={error}
                user={user}
              />
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CreateProjectPage;